import React, { FC, useMemo } from 'react'
import DocumentTitle from 'react-document-title'
import { Spinner } from 'transfix-ui/components/Spinner'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { StringParam, useQueryParams } from 'use-query-params'
import CreateShipmentForm from './components/CreateShipmentForm'
import CreateShipmentFormProvider from './context'
import { OriginalShipmentProvider } from './context/OriginalShipmentProvider'
import { useShipmentInformationQuery } from './graphql/ShipmentInformation'
import { getCreateShipmentSchema } from './utils/getCreateShipmentSchema'

const CreateShipment: FC = () => {
  const [{ shipmentId: cloneShipmentId }] = useQueryParams({
    shipmentId: StringParam,
  })

  // query for fetching data to clone shipment
  const { data, loading } = useShipmentInformationQuery({
    variables: {
      shipmentId: cloneShipmentId || '',
    },
    skip: !cloneShipmentId,
  })

  const defaultValues = useMemo(() => {
    return data ? getCreateShipmentSchema(data) : {}
  }, [data])

  return (
    <div>
      <DocumentTitle title='Create Shipment'>
        <Box p={4}>
          <Typography variant='h2'>Create Shipment </Typography>
        </Box>
      </DocumentTitle>
      <Box px={4}>
        {!loading && (
          <OriginalShipmentProvider defaultValues={data?.shipment ?? null}>
            <CreateShipmentFormProvider defaultValues={defaultValues}>
              <CreateShipmentForm />
            </CreateShipmentFormProvider>
          </OriginalShipmentProvider>
        )}
        {loading && (
          <div>
            <Spinner />
          </div>
        )}
      </Box>
    </div>
  )
}

export default CreateShipment
